import l from "react";
import p from "classnames";
import { T as i } from "./index-Dd-4N6BE.es.js";
import './Title.css';const c = "Title-module__lineClamp___XtXj6", _ = {
  lineClamp: c
}, C = ({
  children: s,
  href: e,
  onClick: t,
  openInNewTab: n = !1,
  maxLines: a,
  tagName: r = "h5"
}) => {
  let m = typeof t == "string" ? t : "";
  e && (m = e);
  const o = {
    className: p(a && _.lineClamp),
    style: a ? { WebkitLineClamp: a } : {}
  };
  return /* @__PURE__ */ l.createElement(i.Heading5, { tagName: r, responsive: !0 }, t ? /* @__PURE__ */ l.createElement(
    "a",
    {
      ...o,
      href: m,
      target: n && e ? "_blank" : void 0
    },
    s
  ) : /* @__PURE__ */ l.createElement("span", { ...o }, s));
};
export {
  C as T
};
